import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SystemAlertsPanel = ({ alerts }) => {
  const getSeverityColor = (severity) => {
    const colorMap = {
      critical: 'border-error bg-error/5',
      warning: 'border-warning bg-warning/5',
      info: 'border-primary bg-primary/5'
    };
    return colorMap?.[severity] || 'border-border bg-card';
  };

  const getSeverityIcon = (severity) => {
    const iconMap = {
      critical: 'AlertCircle',
      warning: 'AlertTriangle',
      info: 'Info'
    };
    return iconMap?.[severity] || 'Bell';
  };

  const getSeverityIconColor = (severity) => {
    const colorMap = {
      critical: 'text-error',
      warning: 'text-warning',
      info: 'text-primary'
    };
    return colorMap?.[severity] || 'text-muted-foreground';
  };

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
          Systeem Meldingen
        </h3>
        <p className="caption text-muted-foreground">
          Belangrijke systeem gebeurtenissen
        </p>
      </div>
      <div className="space-y-3">
        {alerts?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} color="var(--color-success)" className="mx-auto mb-3" />
            <p className="text-sm text-muted-foreground">
              Geen actieve meldingen
            </p>
          </div>
        ) : (
          alerts?.map((alert) => (
            <div
              key={alert?.id}
              className={`
                border rounded-lg p-4 transition-smooth
                ${getSeverityColor(alert?.severity)}
              `}
            >
              <div className="flex items-start gap-3">
                <div className={`flex-shrink-0 ${getSeverityIconColor(alert?.severity)}`}>
                  <Icon name={getSeverityIcon(alert?.severity)} size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-medium text-sm text-foreground mb-1">
                    {alert?.title}
                  </h4>
                  <p className="caption text-muted-foreground mb-2">
                    {alert?.message}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="caption text-muted-foreground">
                      {new Date(alert.timestamp)?.toLocaleString('nl-NL', {
                        day: '2-digit',
                        month: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                </div>
                <Button variant="ghost" size="sm" iconName="X" className="flex-shrink-0" />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SystemAlertsPanel;